import z from "zod";
export const timestampsSchema = {
    createdAt: z.iso.datetime(),
    updatedAt: z.iso.datetime(),
    deletedAt: z.iso.datetime().nullable(),
};
export const paginationQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(50),
});
export function paginatedResponseSchema(itemSchema) {
    return z.object({
        data: itemSchema.array(),
        total: z.number(),
        page: z.number(),
        limit: z.number(),
    });
}
//# sourceMappingURL=helpers.schema.js.map